import { render, staticRenderFns } from "./DashCounter.vue?vue&type=template&id=95d3e57c&"
import script from "./DashCounter.vue?vue&type=script&lang=js&"
export * from "./DashCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports